export const AUTO_SIGN_IN_DISABLED_KEY = "eloriaAutoSignInDisabled";

/**
 * Signing out has to survive the redirect to the login page, otherwise One Tap
 * auto select signs the user straight back in. Google's disableAutoSelect
 * records the same intent on its side, but it races the navigation that
 * follows, so the decision is also kept locally.
 */
export function disableAutoSignIn(): void {
  localStorage.setItem(AUTO_SIGN_IN_DISABLED_KEY, "1");
}

/** Called after a deliberate sign-in, which is Google's condition for
 * resuming automatic sign-in. */
export function enableAutoSignIn(): void {
  localStorage.removeItem(AUTO_SIGN_IN_DISABLED_KEY);
}

export function isAutoSignInDisabled(): boolean {
  return localStorage.getItem(AUTO_SIGN_IN_DISABLED_KEY) !== null;
}
